import l from 'dompurify'

function c() {
  return l()
}
function v(o = {}, i = c) {
  const n = i()
  const t = function(e, r) {
    const u = r.value
    if (r.oldValue === u) { return }
    const a = `${u}`
    const s = r.arg
    const d = o.namedConfigurations
    const f = o.default || {}
    if (d && s !== void 0) {
      e.innerHTML = n.sanitize(
        a,
        d[s] || f
      )
      return
    }
    e.innerHTML = n.sanitize(
      a,
      f
    )
  }
  return {
    inserted: t,
    update: t,
    unbind: (e) => {
      e.innerHTML = ''
    }
  }
}
const y = {
  install(o, i = {}, n = c) {
    o.directive(
      'dompurify-html',
      v(i, n)
    )
  }
}
export {
  y as default,
}
